import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { DriverProcessDetail, DriverProcessHistory } from 'app/models/driverProcess.model';
import { RouteHistory } from 'app/models/route-history.model';
import { DriverProcessService } from 'app/services/driver-process.service';
import { RouteHistoryService } from 'app/services/route-history.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
const iconUrl = 'assets/img/marker-icon.png';
const Defaulticon = L.icon({
    iconUrl,
    iconSize: [25, 25],
    iconAnchor: [5, 20],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerFormIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
L.Marker.prototype.options.icon = Defaulticon;

@Component({
    selector: 'app-route-history',
    templateUrl: './route-history.component.html',
    styleUrls: ['./route-history.component.scss']
})
export class RouteHistoryComponent implements OnInit {

    private map;
    public myLocation: L.LatLng = L.latLng(0, 0);
    public selectedLocation: L.LatLng;
    public driverProcessId:number;
    public markerOpen = false;
    public latitude = 0;
    public longitude = 0;
    public points = "";
    public routeHistory:Array<RouteHistory> = [];
    public driverProcessHistory:Array<DriverProcessHistory> = [];

    constructor(
        public dialogRef: MatDialogRef<RouteHistoryComponent>,
        public _translateService: TranslateService,
        public _routeHistoryService:RouteHistoryService,
        private appConfigService:AppInitializationService,
        public _driverProcessService:DriverProcessService,
        @Inject(MAT_DIALOG_DATA) public data,
        public _toastService: ToasterService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.initMap();
        await this.getRouteHistory();
        await this.getDriveProcessHistory();
        await this.drawDriverProcess();
    }

    public async getRouteHistory(){
        this.routeHistory = await this._routeHistoryService.getRouteHistory(this.driverProcessId);
        await this.drawRoute();
    }
    
    public async getDriveProcessHistory(){
       this.driverProcessHistory =  await this._driverProcessService.getDriverProcessHistory(this.driverProcessId);
    }
    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }
    
    private async initMap(): Promise<void> {

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 8
        });

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });
        tiles.addTo(this.map);
    }

    async drawRoute() {
        var points = this.routeHistory.map(x=>{
            return L.latLng(x.latitude,x.longitude)
        })

        const startMarker = L.marker(points[0], {
            icon: new ContainerFormIcon({ iconUrl: 'assets/img/marker.png' })
        });
        startMarker.addTo(this.map)

        const endMarker = L.marker(points[points.length - 1], {
            icon: new ContainerFormIcon({ iconUrl: 'assets/img/marker.png' })
        });
        endMarker.addTo(this.map)

        var polyline = L.polyline(points, {color: 'red'}).addTo(this.map);

        const bounds = L.latLngBounds(points);
        const center = bounds.getCenter();
        this.map.setView(center,15);
    }

    async drawDriverProcess(){
        if(this.driverProcessHistory.length==0){
            return;
        }

        var coordinates = [];
        var car = this.driverProcessHistory[0].car;
        coordinates.push(new L.LatLng(car.eLatitude,car.eLongitude))
        this.driverProcessHistory.forEach(x=>{
            coordinates.push(new L.LatLng(x.container.latitude,x.container.longitude))
        })

        L.Routing.control({
            waypoints: coordinates,   
            lineOptions: {
                styles: [{ color: 'blue', opacity: 0.6, weight: 5 }]
            },
            plan: L.Routing.plan(
                coordinates,
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            serviceUrl: this.appConfigService.apiConfig["routing-url"], //'http://127.0.0.1:5000/route/v1',
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(this.map);
    }
}
